import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorModalHelperService } from '../../_helpers/error-modal-helper/error-modal-helper.service';
import { environment } from '../../../environments/environment';
import { BaseService } from '../base/base.service';
import { SessionUserHashManagerService } from '../session-user-hash-manager/session-user-hash-manager.service';

@Injectable({
  providedIn: 'root'
})
export class SpinnerService extends BaseService {
  
  public hints: string[] = new Array<string>();

  private endpoint: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    protected hashManagerService: SessionUserHashManagerService,
    private errorModalHelper: ErrorModalHelperService
    ) {
    super(hashManagerService);
    this.endpoint += this.endpoint.endsWith("/") ? "" : "/";
  }

  public populateHints(): void {
    this.getSpinnerHints().subscribe(hintList => {
      this.hints = hintList;
    }, error => {
      console.error(error);
      this.errorModalHelper.show(error.message, error);
    });
  }

  private getSpinnerHints() {
    // return this.httpClient.get(this.endpoint + 'api/General/GetSpinnerHints/', this.prepareOptions(null)).pipe(
    //     map((data: any) => {
        
    //     if (data.status === 299) {
    //       throw {
    //         message: data.body,
    //         status: data.status,
    //         isValidationError: true
    //       };
    //     } else {
    //       return data.body;
    //     }
    //   }), catchError(this.handleError('getSpinnerHints'))
    // );

    this.hints.push("The sidebar can be pinned for easier access");
    this.hints.push("Need more space, hide the utility bar by clicking the up arrow");
    this.hints.push("The 'back to top' button at the bottom of the page will scroll you back to the top");
    this.hints.push("Tuition Co-ordinations can unlock approved sessions");
    this.hints.push("Useful links can be found at the bottom of every page");
    this.hints.push("New functionality missing? Try pressing Ctrl and F5 to refresh your version");
    this.hints.push("The logout button can be found by clicking on your profile icon at the top right of the page");
    this.hints.push("Most screens have a button at the bottom left that allows you to alter the number of items displayed");
    this.hints.push("Click the company logo to return home");
    this.hints.push("All times are shown in 24-hour notation");
    this.hints.push("Take care when logging student attendance, as it affects timesheets");

    return of(this.hints);
  }

}
